import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-027055f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-form" }
const _hoisted_2 = {
  key: 0,
  class: "text-center text-red mt-2"
}
const _hoisted_3 = { class: "pt-4 pb-4 fex w-full" }
const _hoisted_4 = { class: "flex justify-content-center mb-3" }
const _hoisted_5 = { class: "flex flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "username",
  class: "mb-2"
}, [
  /*#__PURE__*/_createTextVNode("アカウント名"),
  /*#__PURE__*/_createElementVNode("small", { class: "required pl-2" }, "必須")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { id: "username-help" }, null, -1))
const _hoisted_8 = { class: "flex justify-content-center mb-5" }
const _hoisted_9 = { class: "flex flex-column" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "mb-2"
}, [
  /*#__PURE__*/_createTextVNode("パスワード"),
  /*#__PURE__*/_createElementVNode("small", { class: "required pl-2" }, "必須")
], -1))
const _hoisted_11 = { class: "flex justify-content-center" }
const _hoisted_12 = { class: "flex flex-column" }
const _hoisted_13 = { class: "forgot-password flex justify-content-end" }

import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";
import { ref, reactive, onMounted, computed } from "vue";
import rules from "./rules";
import { get, set } from "@vueuse/core";
import * as _ from "lodash";
import { ClinicService } from "../../services";
import { ApiSignInRequest, ApiSignInResponse } from "../../typings";
import { useAsyncValidator } from "@vueuse/integrations/useAsyncValidator";
import { ValidateError } from "async-validator";
import { useStore } from "vuex";
import { AxiosResponse } from "axios";
import { BookingViewPageTypeEnum } from "@/clinic/typings/enums/booking";


export default /*#__PURE__*/_defineComponent({
  __name: 'form',
  setup(__props) {

const store = useStore();
const errorMessage = ref<string | null>(null);
const formLogin = reactive({ username: "", password: "" });
const initValidation = computed(() => {
  return useAsyncValidator(formLogin, rules);
});
const validate = async (): Promise<boolean> => {
  const { execute } = get(initValidation);
  const { pass: fPass, errorFields: fErrorFields, errors: fErrors } = await execute();
  set(pass, get(fPass));
  set(errorFields, get(fErrorFields));
  set(errors, get(fErrors));
  return get(pass) as boolean;
};
const pass = ref(false);
const errorFields = ref<{ [key: string]: ValidateError | ValidateError[] }>();
const errors = ref<ValidateError[]>([]);
const onSubmit = async () => {
  if (!(await validate())) return;

  const { data } = (await ClinicService.signIn(
    formLogin as unknown as ApiSignInRequest,
    () => undefined,
    error => {
      errorMessage.value = error;
    }
  )) as unknown as AxiosResponse<ApiSignInResponse>;
  const { access_token } = get(data);
  store.commit("authClient/setAccessToken", access_token);
  store.dispatch("authClient/saveAccessTokenCookie");
  redirectBookingPage();
};
const redirectDashboard = async () => {
  if (!(await store.dispatch("authClient/checkAccessTokenCookie"))) return;

  return RouterUtils.goTo(RouterConstants.DASHBOARD_ROUTER_NAME);
};

const redirectBookingPage = async () => {
  if (!(await store.dispatch("authClient/checkAccessTokenCookie"))) return;

  return RouterUtils.goToWithQuery(RouterConstants.BOOKING_ROUTER_NAME, {
    view_page: BookingViewPageTypeEnum.StaffCalendar,
  });
};

const goToForgotPassword = () => {
  RouterUtils.goTo(RouterConstants.FORGOT_PASSWORD_ROUTER_NAME);
};
onMounted(() => {
  redirectBookingPage();
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((!pass.value && errors.value?.length) || errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_.head(errors.value)?.message || errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_InputText, {
            modelValue: formLogin.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formLogin.username) = $event)),
            "aria-describedby": "username-help",
            type: "text",
            size: "large",
            name: "username",
            placeholder: "メールアドレス",
            class: _normalizeClass([{ 'p-invalid': errorFields.value?.username }, "w-284"])
          }, null, 8, ["modelValue", "class"]),
          _hoisted_7
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_Password, {
            modelValue: formLogin.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formLogin.password) = $event)),
            "aria-describedby": "password-help",
            type: "text",
            size: "large",
            name: "password",
            placeholder: "半角英数",
            class: _normalizeClass([{ 'p-invalid': errorFields.value?.password }, "w-284"]),
            feedback: false,
            toggleMask: ""
          }, null, 8, ["modelValue", "class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_Button, {
            label: "ログイン",
            class: "w-284",
            onClick: onSubmit
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_Button, {
        label: "パスワードを忘れた方",
        class: "p-button-link",
        onClick: goToForgotPassword
      })
    ])
  ]))
}
}

})